import {getHostName, getLastPrice} from "../../utils/Utils";

// Whether the campaign's site/seller settings switch this seller off. Mirrors the price
// check's is_campaign_based_competitor_active (pricescraper), which decides the same thing
// from the same settings.
export const isCampaignInactiveSeller = (campaign, competitor) => {
    const hostname = getHostName(competitor.product_url);
    if (campaign.new_seller_automatically_activated)
        return !!(campaign.inactive_sellers?.has(competitor.name) || campaign.inactive_sellers?.has(hostname));
    return !(campaign.active_sellers?.has(competitor.name) || campaign.active_sellers?.has(hostname));
};

// The customer's own row, currently without an observation because its seller is switched
// off in the campaign: the check wrote a synthetic stock 0 row, so "out of stock" would be
// the wrong thing to say. Keyed on the row itself so a real observation is never relabelled.
export const isOwnRowCampaignInactive = (campaign, competitor) => {
    if (!campaign || !competitor?.is_mine)
        return false;
    return getLastPrice(competitor.prices)?.availability === 'inactive'
        && isCampaignInactiveSeller(campaign, competitor);
};
